import { SVGProps } from 'react'

export const Search = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.625 15.125C10.0095 15.125 11.3628 14.7145 12.514 13.9453C13.6651 13.1761 14.5623 12.0829 15.0922 10.8038C15.622 9.5247 15.7606 8.11724 15.4905 6.75937C15.2204 5.4015 14.5537 4.15422 13.5747 3.17526C12.5958 2.19629 11.3485 1.5296 9.99063 1.25951C8.63277 0.98941 7.2253 1.12803 5.94622 1.65785C4.66713 2.18766 3.57388 3.08487 2.80471 4.23601C2.03554 5.38716 1.625 6.74053 1.625 8.125C1.625 9.98152 2.3625 11.762 3.67525 13.0747C4.98801 14.3875 6.76848 15.125 8.625 15.125Z"
      stroke="#B0B7C3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3753 16.8753L13.5693 13.0693"
      stroke="#B0B7C3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
